/****************************************************************************************************
 * hogr -> page-home > graphic
****************************************************************************************************/
import { getCSSVariableResolvedValue } from "./utils";
import { hoemElsControl } from "./page-home-email";


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let hogrIsSnippet = true;
// if(hogrIsSnippet && typeof hogrIsRevert !== 'undefined') {
//   hogrScrollClear();
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let windowH; // jess: windowH instead of window.innerHeight
let hogrSel = '.sector.graphic ';



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation
let hogrScrollTl1;
let hogrScrollTl2;
let hogrScrollTl3;
let hogrGraphicOnTl;
let hogrTitle; // eslint-disable-line no-unused-vars
let hogrCopyTl; // eslint-disable-line no-unused-vars
let hogrCardsY = 0;
let hogrCardsScale = 1;

const hogrInit = (gsapRef, splitTextRef) => {
  windowH = document.documentElement.getBoundingClientRect().height;
  // windowH = window.innerHeight;

  gsapRef.set('.sector.graphic', {pointerEvents: 'none'});

  gsapRef.set('.sector.graphic .graphic-deco, .sector.graphic .graphic-cards, .sector.graphic .graphic-card, .sector.graphic .graphic-card-in',{clearProps: 'all'});
  gsapRef.set('.sector.email .brain-step-g, .sector.email #brain-route-path, .sector.email .email-steps, .sector.email #brain-whole, .sector.email .butterfly-vector-in', {clearProps: 'opacity'});

  // gsapRef.set('.sector.graphic .container-in', {y: 0, opacity: 0});
  gsapRef.set('.sector.graphic .container-in', {y: -window.innerHeight, opacity: 0});

  hogrTitle = new splitTextRef('.sector.graphic .contents-wrapper.graphic .sector-copy.title .copy', {type: 'chars,words', charsClass:'char char++'});
  gsapRef.set('.sector.graphic .contents-wrapper.graphic .sector-copy.title .copy .char', {transformOrigin: 'left center', autoAlpha: 0, rotationX: '70deg', y: '20%', x: '-70%'});
  gsapRef.set('.sector.graphic .contents-wrapper.graphic .sector-copy.sentance .copy span', { clearProps: 'all' });
  gsapRef.set('.sector.graphic .contents-wrapper.graphic .sector-copy.sentance .copy span', { autoAlpha: 0,  y: '70%'});

  hogrCardsScale = parseFloat(getCSSVariableResolvedValue('flex-grow', '.sector.graphic .container', '--hogr-cards-scale')) + 0.005; // Add 0.005 to have enough size so in portrait, there is no gab on the bottom
  hogrCardsY = -1 * (parseFloat(getCSSVariableResolvedValue('width', '.sector.graphic .graphic-cards', '--hogr-cards-y1')) + 
    parseFloat(getCSSVariableResolvedValue('width', '.sector.graphic .graphic-cards', '--hogr-cards-y2')));
  gsapRef.set('.sector.graphic .graphic-cards', {y: hogrCardsY, scale: hogrCardsScale});
  gsapRef.set('.sector.graphic .graphic-card-in.no1', {filter: 'blur(1.4vw)'}); 
  gsapRef.set('.sector.graphic .graphic-card .glass-cover-glow', {opacity: 0}); 

  gsapRef.set('.sector.graphic .graphic-deco', {opacity: 0});
}

const hogrScrollMake = (gsapRef, scrollTriggerRef, smootherRef) => {
  
  let pinGrCardsShow = 0.4; // Pin while graphic cards showing
  
  ////////////////////////////// Scroll1: Pin graphic over email & Show graphic cards
  hogrScrollTl1 = gsapRef.timeline({
    scrollTrigger: {
    id: 'hogrScrollTl1',
    trigger: hogrSel,
    toggleActions: 'restart complete reverse reset',
    // start: 'top top',
    // end: `+=${pinGrCardsShow * 100}%` , // Used from .spacer-graphic
    start: 'top bottom',
    end: `+=${pinGrCardsShow * 100 + 100}%` , // pinGrCardsShow * 100: Used from .spacer-graphic
    scrub: true,
    toggleClass: 'hogrScrollTl1-active',
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  // .to('.sector.graphic .container-in', {duration: 0.4, y: '+='+(window.innerHeight * pinGrCardsShow), ease: 'none'})
  // .to('.sector.graphic .container-in', {duration: 0.4, y: '+='+(Math.ceil(windowH) * pinGrCardsShow), ease: 'none'}) 

  // .to('.sector.graphic .container-in', {duration: 0.4, y: '+='+(windowH * pinGrCardsShow), ease: 'none'}) 
  // .to('.sector.graphic .graphic-cards', {duration: 0.2, y: '0px', scale: 1, ease: 'power1.out'}, 0.2)

  .to('.sector.graphic .container-in', {duration: 1.4, y: '+='+(windowH * pinGrCardsShow + windowH), ease: 'none'}) 
  .to('.sector.graphic .graphic-cards', {duration: 0.25, y: '0px', scale: 1, ease: 'power1.out'}, 1.1)
  .to('.sector.graphic .graphic-card .glass-cover-glow', {duration: 0.25, opacity: 1, ease: 'power1.out'}, 1.1)
  ;

  ////////////////////////////// Scroll2: Parallax
  hogrScrollTl2 = gsapRef.timeline({
    scrollTrigger: {
    id: 'hogrScrollTl2',
    trigger: hogrSel,
    toggleActions: 'restart complete reverse reset',
    start: 'top top',
    end: `bottom ${(1-pinGrCardsShow) * 100}%`,
    scrub: 1.5,
    toggleClass: 'hogrScrollTl2-active',
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  .fromTo(".sector.graphic .graphic-deco.bar-pattern", {y: '-20%'}, {duration: 1, y: '20%', ease: 'none'}, 0)

  .to(".sector.graphic .graphic-deco.flower-purple", {duration: 0.8, y: '110%', ease: 'power1.out'}, 0)
  .to(".sector.graphic .graphic-deco.flower-blue", {duration: 0.8, y: '170%', ease: 'power1.out'}, 0)
  .to(".sector.graphic .graphic-deco.flower-unknown", {duration: 0.8, y: '200%', ease: 'power1.out'}, 0)
  .to(".sector.graphic .graphic-deco.flower-orange", {duration: 0.8, y: '200%', ease: 'power1.out'}, 0)

  .fromTo(".sector.graphic .graphic-deco.bird-blue", {y: '-55%'}, {duration: 0.8, y: '60%', ease: 'power2.out'}, 0)
  .fromTo(".sector.graphic .graphic-deco.bird-green", {y: '-90%'}, {duration: 0.8, y: '80%', ease: 'power2.out'}, 0)
  .fromTo(".sector.graphic .graphic-deco.fruit-orange", {y: '-60%'}, {duration: 0.8, y: '90%', ease: 'power3.out'}, 0)
  .fromTo(".sector.graphic .graphic-deco.fruit-red", {y: '-170%'}, {duration: 0.8, y: '80%', ease: 'power2.out'}, 0)
  .fromTo(".sector.graphic .graphic-deco.flower-white.white1", {y: '-50%'}, {duration: 0.8, y: '40%', ease: 'power2.out'}, 0)
  .fromTo(".sector.graphic .graphic-deco.flower-white.white2", {y: '-100%'}, {duration: 0.8, y: '80%', ease: 'power1.out'}, 0)
  .fromTo(".sector.graphic .graphic-deco.arrow-yellow", {y: '-105%'}, {duration: 0.8, y: '140%', ease: 'none'}, 0)
  .fromTo(".sector.graphic .graphic-deco.arrow-blue", {y: '-101%'}, {duration: 0.9, y: '330%', ease: 'none'}, 0)
  .fromTo(".sector.graphic .graphic-deco.feather-a-blue", {y: '-400%'}, {duration: 0.8, y: '550%', ease: 'none'}, 0)
  .fromTo(".sector.graphic .graphic-deco.feather-d-purple", {y: '-350%'}, {duration: 1, y: '700%', ease: 'none'}, 0)
  .fromTo(".sector.graphic .graphic-deco.feather-b-yellow", {y: '-400%'}, {duration: 1, y: '1500%', ease: 'none'}, 0)

  .fromTo(".page.page-home .graphic-deco.flower-pink", {y: '-80%'}, {duration: 0.8, y: '90%', ease: 'power1.out'}, 0.1)
  .fromTo(".page.page-home .graphic-deco.leaves", {y: '-100%'}, {duration: 0.8, y: '80%', ease: 'power1.out'}, 0.1)

  .fromTo(".page.page-home .graphic-deco.deer", {y: '250%'}, {duration: 1, y: '-100%', ease: 'power1.inOut'}, 0)

  .fromTo(".sector.graphic .graphic-card.no2", {y: '-20%'}, {duration: 1, y: '180%', ease: 'power1.inOut'}, 0)
  .fromTo(".sector.graphic .graphic-card.no3", {y: '100%'}, {duration: 1, y: '-150%', ease: 'power1.inOut'}, 0)
  .fromTo(".sector.graphic .graphic-card.no4", {y: '50%'}, {duration: 1, y: '0%', ease: 'power1.inOut'}, 0)
  .fromTo(".sector.graphic .graphic-card.no5", {y: '60%'}, {duration: 0.8, y: '-10%', ease: 'power1.inOut'}, 0.1)
  .fromTo(".sector.graphic .graphic-card.no6", {y: '150%'}, {duration: 0.8, y: '-60%', ease: 'none'}, 0.1)

  .fromTo(".sector.graphic .graphic-card.no1 .graphic-card-in", {y: '0%', scale: 1}, {duration: 0.4, scale: 1.3, ease: 'power1.inOut'}, 0.1)
  .fromTo(".sector.graphic .graphic-card.no2 .graphic-card-in", {y: '0%', scale: 1.3}, {duration: 0.6, y: '-44%', scale: 1, ease: 'power1.out'}, 0.1)
  .fromTo(".sector.graphic .graphic-card.no3 .graphic-card-in", {y: '0%', scale: 1}, {duration: 0.6, y: '-16%', scale: 1.3, ease: 'power1.inOut'}, 0.1)
  .fromTo(".sector.graphic .graphic-card.no4 .graphic-card-in", {y: '0%', scale: 1.4}, {duration: 0.7, y: '-33%', scale: 1, ease: 'power2.inOut'}, 0.2)
  .fromTo(".sector.graphic .graphic-card.no5 .graphic-card-in", {y: '0%', scale: 1}, {duration: 0.7, y: '-33%', scale: 1.1, ease: 'power3.inOut'}, 0.3)
  .fromTo(".sector.graphic .graphic-card.no6 .graphic-card-in", {y: '0%', scale: 1.3}, {duration: 0.7, y: '-33%', scale: 1, ease: 'power3.in'}, 0.3)
  ;

  ////////////////////////////// Scroll3: Pin graphic while photograph show and photograph on
  let amount1 = (1-pinGrCardsShow) * windowH;
  let amount2 = (1-pinGrCardsShow + 1 + 1) * windowH;

  hogrScrollTl3 = gsapRef.timeline({
    scrollTrigger: {
    id: 'hogrScrollTl3',
    trigger: hogrSel,
    toggleActions: 'restart complete reverse reset',

    // start: `bottom ${(1-pinGrCardsShow) * 100}%`,
    // end: `+=${(1-pinGrCardsShow) * 100 + 100 + 100}%` , // jess: Used from .spacer-graphic & .sector.photo-retouching

    start: `bottom ${amount1}px`,
    end: `+=${amount2}px` , // jess: Used from .spacer-graphic & .sector.photo-retouching

    scrub: true,
    toggleClass: 'hogrScrollTl3-active',
    // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  // .to('.sector.graphic .container-in', {duration: 1-pinGrCardsShow + 1 + 1, y: '+='+(window.innerHeight * (1-pinGrCardsShow + 1 + 1)), ease: 'none'}) // jess: Used from .spacer-graphic & .sector.photo-retouching
  // .to('.sector.graphic .container-in', {duration: 1-pinGrCardsShow + 1 + 1, y: '+='+(Math.ceil(windowH) * (1-pinGrCardsShow + 1 + 1)), ease: 'none'}) // jess: Used from .spacer-graphic & .sector.photo-retouching
  .to('.sector.graphic .container-in', {duration: 1-pinGrCardsShow + 1 + 1, y: '+='+amount2, ease: 'none'}) // jess: Used from .spacer-graphic & .sector.photo-retouching

  .to('.sector.graphic .contents-wrapper.photography-bg', {duration: 0.1, backgroundColor: "rgba(0, 0, 0, 1)", ease: 'power1.out'}, 0)  
  
  .to('.sector.graphic .contents-wrapper.photography', {duration: 0.1 + 0.05, x: 0, ease: 'power1.in'}, 0)
  .to('.sector.graphic .contents-wrapper.photography', {duration: (1-pinGrCardsShow)/2, scale: 1, ease: 'power1.in'}, (1-pinGrCardsShow)/2)
    .to('.sector.graphic .contents-wrapper.photography .photography-in', {duration: (1-pinGrCardsShow)/2, scale: 1, ease: 'power1.in'}, (1-pinGrCardsShow)/2)
  ;

  
  ////////////////////////////// Graphic on
  hogrGraphicOnTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'hogrGraphicOnTl',
      trigger: hogrSel,
      start: 'top top',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        smootherRef.paused(true);
        
      },
      // onLeave: (self) => {},
      onEnterBack: (self) => {
        smootherRef.paused(true);

        hoemElsControl('play'); // hoem elements play
      },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => {
      smootherRef.paused(false);

      hoemElsControl('pause'); // hoem elements pause

      gsapRef.set('.sector.graphic', {pointerEvents: 'auto'});
    },
    onReverseComplete: () => {
      smootherRef.paused(false);
      
      gsapRef.set('.sector.graphic', {pointerEvents: 'none'});
    }
  })
  .addLabel('t0', 0)

  .to('.sector.email #brain-route-path', {duration: 0.2, opacity: 0, ease: 'power1.out'})
  .to('.sector.email .brain-step-g', {duration: 0.1, opacity: 0, stagger: 0.1, ease: 'power1.out'}, '-=0')
  .to('.sector.email .butterfly-vector-in', {duration: 0.3, opacity: 0, ease: 'power2.out'}, '-=0')
  .to('.sector.email #brain-whole', {duration: 0.4, opacity: 0, ease: 'power1.out'}, '-=0.1')
  .to('.sector.email .email-steps', {duration: 0.5, opacity: 0, ease: 'power1.out'}, '-=1')
  .to('.sector.email .email-bg:not(.email-bg-1)', {duration: 0.3, opacity: 0, stagger: 0.1, ease: 'power1.out'}, '-=1')

  .to('.sector.graphic .container-in', {duration: 0.2, opacity: 1, ease: 'power1.in'}, '-=0.2')
  .to('.sector.graphic .graphic-card-in.no1', {duration: 0.8, filter: 'blur(0vw)', ease: 'none'}, '-=0.2')
  .to('.sector.graphic .graphic-deco', {duration: 0.15, opacity: 1, ease: 'power1.in', stagger: -0.1}, '-=1')
  ;

  ////////////////////////////// sector copy show
  hogrCopyTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'hogrCopyTl',
      trigger: hogrSel,
      // start: () => 'top ' + (window.innerHeight - window.innerWidth * 0.3) + 'px',
      // end: () => '+=0.1%',
      start: () => `top -${(pinGrCardsShow - 0.15) * 100}%`,
      end: () => '+=0',
      toggleActions: 'restart none reverse none',
      // markers: {startColor: "green", endColor: "green", fontSize: "10px", fontWeight: "bold", indent: 200}
    }
  })
  .to('.sector.graphic .contents-wrapper.graphic .sector-copy.title .copy .char', {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'})
  .to('.sector.graphic .contents-wrapper.graphic .sector-copy.sentance .copy span', {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, '-=0.25');

} // hogrScrollMake END

const hogrScrollClear = () => {
  if(hogrScrollTl1) {hogrScrollTl1.revert(); hogrScrollTl1 = null}
  if(hogrScrollTl2) {hogrScrollTl2.revert(); hogrScrollTl2 = null}
  if(hogrScrollTl3) {hogrScrollTl3.revert(); hogrScrollTl3 = null}
  if(hogrGraphicOnTl) {hogrGraphicOnTl.revert(); hogrGraphicOnTl = null}
  if(hogrTitle) {hogrTitle.revert(); hogrTitle = null}
  if(hogrCopyTl) {hogrCopyTl.revert(); hogrCopyTl = null}
}

////////// Code for snippet
// if(hogrIsSnippet) {
//   hogrInit(gsap, splitText);
//   hogrScrollMake(gsap, scrollTrigger, smoother);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control -> No Need



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing

const hogrResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home graphic] Resize: START");
}

const hogrResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home graphic] Resize: END");

  hogrScrollClear();
  hogrInit(gsapRef, splitTextRef);
  hogrScrollMake(gsapRef, scrollTriggerRef, smootherRef);
}

////////// Code for snippet
// let hogrResizing = false;
// const hogrResizeHandler = (e) => {
//   if(!hogrResizing) {
//     hogrResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     hogrResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     hogrResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     hogrResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }, 1000, 'hogrResize');
// }
// if(hogrIsSnippet) {
//   if(typeof hogrIsRevert !== 'undefined') window.removeEventListener('resize', hogrResizeHandlerRef);
//   window.hogrResizeHandlerRef = hogrResizeHandler;
//   window.addEventListener('resize', hogrResizeHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key -> No Need



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(hogrIsSnippet) var hogrIsRevert = true;



//////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  hogrInit,
  hogrScrollMake,
  hogrScrollClear,
  hogrResizeStart,
  hogrResizeDone
}